export const fetchAvailableCourses = async (setAvailableCourses, setStatusMessage) => {
    try {
      const response = await fetch(
        "https://wad-backend.ws381566.remote.ac/getAvailableCourses.php?adminRequired=false",
        {
          method: "GET",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          mode: "cors",
        }
      );
  
      const result = await response.json();
  
      if (result.status === "authenticationError") {
        window.location.href = "/login";
        return;
      }
  
      if (result.status === "success") {
        setAvailableCourses(result.courses);
      } else {
        setStatusMessage(result.message || "Failed to fetch courses");
      }
    } catch (error) {
      setStatusMessage(error.message);
    }
};